import { ChatContainer } from './components/Chat';
import { LoadingScreen, LoginScreen, BetaDeniedScreen } from './components/Auth';
import { useAuth } from './hooks/useAuth';
import { isUserAllowedInBeta } from './config/betaAccess';

function App() {
  const { isAuthenticated, isLoading, loginUrl, userId } = useAuth();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated && loginUrl) {
    return <LoginScreen loginUrl={loginUrl} />;
  }

  if (!isUserAllowedInBeta(userId)) {
    return <BetaDeniedScreen />;
  }

  return <ChatContainer />;
}

export default App;
